import SimpleBreadcrumbs from "../../../../components/SimpleBreadCrumb/SimpleBreadCrumb";
import { OrderItem } from "../../components";
import { getProductReviewBreadcrumbs } from "../productReviewPage/data/productReviewBreadcrumbs";
import PurchaseDetailData from "./components/purchaseDetailData/PurchaseDetailData";
import styles from "./purchaseDetailPage.module.scss";
import useFetchData from "../../../../hooks/useFetchData";
import { useParams } from "react-router";
import useCompanyStore from "../../../../Store/supplierCompany/companyData";

const PurchaseDetailPage = () => {
  const { companyName } = useCompanyStore();
  const { id } = useParams<{ id: string }>();
  const { data: purchase } = useFetchData(`/v2/orders/${id}/`);
  return (
    <section className="layout-dashboard-container">
      <div className={styles.purchaseDetailPage}>
        <div className="container">
          <div>
            <SimpleBreadcrumbs
              breadcrumbs={getProductReviewBreadcrumbs(
                companyName ?? undefined
              )}
            />
          </div>
          {purchase && (
            <>
              <section className="section">
                <PurchaseDetailData purchase={purchase} />
              </section>
              <section>
                <div>
                  <OrderItem purchase={purchase} isViewingOrderDetail />
                </div>
              </section>
            </>
          )}
        </div>
      </div>
    </section>
  );
};
export default PurchaseDetailPage;
